import { useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import {
  ConfirmPrimitiveReservationInput,
  MakePrimitiveReservation
} from '../../types/cart'
import BookerDetailsForm from './components/BookerDetailsForm'
import GuestsDetailsForm from './components/GuestsDetailsForm'
import SelectedRoomList from './components/SelectedRoomList'

type StepTwoProps = {
  primitiveData: MakePrimitiveReservation | undefined
  confirmPrimitiveInput: ConfirmPrimitiveReservationInput
  setConfirmPrimitiveInput: React.Dispatch<
    React.SetStateAction<ConfirmPrimitiveReservationInput>
  >
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  setRedirectTitle: React.Dispatch<React.SetStateAction<string>>
  isTimeExpired: boolean
  setIsTimeExpired: React.Dispatch<React.SetStateAction<boolean>>
}

const StepTwo = ({
  primitiveData,
  confirmPrimitiveInput,
  setConfirmPrimitiveInput,
  isTimeExpired,
  setShowModal,
  setRedirectTitle,
  setIsTimeExpired
}: StepTwoProps) => {
  const [optionReservationExpiry, setOptionReservationExpiry] = useState(false)
  const [fillBookerDetalisEnabled, setFillBookerDetalisEnabled] =
    useState(false)

  useEffect(() => {
    if (fillBookerDetalisEnabled) {
      setConfirmPrimitiveInput((prev) => ({
        ...prev,
        confirmRooms: prev.confirmRooms.map((room) => ({
          ...room,
          profiles: room.profiles.map((profile) => ({
            ...profile,
            firstName: prev.booker.firstName,
            lastName: prev.booker.lastName,
            email: prev.booker.email,
            identificationNo: prev.booker.identificationNo,
            mobile: prev.booker.mobile,
            isForeigner: false
          }))
        }))
      }))
    }
  }, [fillBookerDetalisEnabled])

  useEffect(() => {
    if (isTimeExpired) {
      setRedirectTitle(
        getTranslate(
          'Your time has been expired. You will be redirect to booking page'
        )
      )
      setShowModal(true)
      localStorage.removeItem('confirmPrimitiveInput')
      localStorage.removeItem('confirmPrimitiveReservationState')
      localStorage.removeItem('hotelDetails')
      localStorage.removeItem('primitiveData')
      setIsTimeExpired(false)
    }
  }, [isTimeExpired])

  return (
    <>
      <SelectedRoomList items={primitiveData?.selectedRooms} />
      <BookerDetailsForm
        confirmPrimitiveInput={confirmPrimitiveInput}
        setConfirmPrimitiveInput={setConfirmPrimitiveInput}
        setOptionReservationExpiry={setOptionReservationExpiry}
        optionReservationExpiry={optionReservationExpiry}
        setFillBookerDetalisEnabled={setFillBookerDetalisEnabled}
        showDiscount={primitiveData?.isAutorizedToDeclareDiscount || false}
        showOtionReserveExpiryTime={
          primitiveData?.isAuthorizedToDeclareOptionReserve || false
        }
        showReservationType={primitiveData?.showReservationType || false}
        optionReserveMaxExpireTime={
          primitiveData?.optionReserveMaxExpireTime || ''
        }
      />
      {confirmPrimitiveInput.confirmRooms.length > 0 &&
        primitiveData?.roomStays.map((room, roomIndex) => (
          <GuestsDetailsForm
            key={roomIndex}
            confirmPrimitiveInput={confirmPrimitiveInput}
            setConfirmPrimitiveInput={setConfirmPrimitiveInput}
            roomDetails={room}
            roomIndex={roomIndex}
            max={room.occupancy.adults + room.occupancy.extraBeds || 1}
          />
        ))}
    </>
  )
}

export default StepTwo
